import { Link } from 'react-router';
import { compareVersions, type SystemVersion } from '@mcpanel/core';
export function hasUpdate(data?: SystemVersion) {
  return !!data?.update?.latest && !data.update.error && compareVersions(data.update.latest, data.version) > 0;
}
export function UpdateBanner({ data, role }: { data?: SystemVersion; role?: string }) {
  if (!['owner', 'admin'].includes(role ?? '') || !hasUpdate(data)) return null;
  return (
    <div role="status" className={`alert ${data?.update?.security ? 'warn' : 'info'}`}>
      {data?.update?.security ? 'セキュリティ修正を含む更新があります' : '新しい版があります'}{' '}
      <Link to="/settings">更新の詳細（{data?.update?.latest}）</Link>
    </div>
  );
}
